import { useEffect } from "react";

function setMeta(selector, attribute, content) {
  const element = document.querySelector(selector);
  if (element) element.setAttribute(attribute, content);
}

export function SeoMetadata({ description, title }) {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
  }, [description, title]);
  return null;
}

export function NoIndex() {
  useEffect(() => {
    setMeta('meta[name="robots"]', "content", "noindex,nofollow,noarchive");
    return () => setMeta('meta[name="robots"]', "content", "index,follow");
  }, []);
  return null;
}